import { computed, inject, type Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectPlanIsAtleastBasic } from '@reducers/account/account-subscription.selector';
import { selectAccountHasHrPlus, selectAccountIsOnTrial } from '@reducers/account/account.selector';
import { AppState } from '@reducers/interfaces';
import { selectPermissionCanAccessAccountSettings } from '@reducers/orm/permission/permission.selectors';
import { featureFlag, FeatureService } from '@sb/shared/feature';

import { isHrProUpsellApplicable } from './hr-pro-upsell.access';

export const useHrProOrUpsellVisible = (): Signal<boolean> => {
  const store = inject<Store<AppState>>(Store);
  const upsellEnabled = inject(FeatureService).isEnabledSignal(featureFlag.TMP_HR_PRO_UPSELL);
  const hasHrPro = store.selectSignal(selectAccountHasHrPlus);
  const canAccessSettings = store.selectSignal(selectPermissionCanAccessAccountSettings);
  const planIsAtleastBasic = store.selectSignal(selectPlanIsAtleastBasic);
  const isOnTrial = store.selectSignal(selectAccountIsOnTrial);

  return computed(
    () =>
      hasHrPro() ||
      isHrProUpsellApplicable({
        featureEnabled: upsellEnabled(),
        hasHrPro: hasHrPro(),
        canAccessSettings: canAccessSettings(),
        planIsAtleastBasic: planIsAtleastBasic(),
        accountIsOnTrial: isOnTrial() ?? false,
      }),
  );
};
